export const STATUS = {
  NEW: 'NEW',
  IN_CONTACT: 'In Contact',
  APPLYING: 'Applying',
  REJECTED: 'Rejected',
  CONVERTED: 'Converted',
  BOOKED_SHOWING: 'Booked Showing',
  STALE: 'Stale',
  WAITLISTED: 'Waitlisted',
  PENDING_APPLICANTS: 'Pending Application',
  PENDING_SIGNATURE: 'Pending Signature',
  PENDING_DEPOSIT: 'Pending Deposit',
  PENDING_LEASES: 'Pending Lease Submission from Landlord',
};

export const PROSPECTS_STATUS = {
  NEW: 8,
  IN_CONTACT: 0,
  APPLYING: 1,
  REJECTED: 2,
  CONVERTED: 3,
  BOOKED_SHOWING: 4,
  STALE: 5,
  WAITLISTED: 6,
  CLOSED: 7,
};
